module.exports = __webpack_public_path__ + "img/iconDevice-Gray.22353a64.svg";